// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--n_y1F","_white":"_9e1425b4d3--_white--ygih7","_gray":"_9e1425b4d3--_gray--oXENi"};